import moment from "moment/moment";

export default function (
  posOrderListData,
  posOrderAmountField,
  posOrderCountField,
  posDateField,
  posTypeField,
  onlineOrderListData,
  onlineOrderAmountField,
  onlineOrderCountField,
  onlineDateField,
  onlineTypeField,
  minCol = 12
) {
  const posOrderList = posOrderListData || [];
  const onlineOrderList = onlineOrderListData || [];
  const dateMap = {};
  const createEmptyEntry = () => ({
    posProductAmount: 0,
    posProductCount: 0,
    posServiceAmount: 0,
    posServiceCount: 0,
    posRealestateAmount: 0,
    posRealestateCount: 0,
    onlineProductAmount: 0,
    onlineProductCount: 0,
    onlineServiceAmount: 0,
    onlineServiceCount: 0,
    onlineRealestateAmount: 0,
    onlineRealestateCount: 0,
  });
  const toNumber = (value) => +parseFloat(value || 0).toFixed(2);
  const normalizeType = (value) =>
    `${value || ""}`.toUpperCase().replace(/[\s_-]/g, "");
  const setEntry = (list, amountField, countField, dateField, typeField, key) => {
    list.forEach((item) => {
      const date = item?.[dateField];
      const type = normalizeType(item?.[typeField]);

      if (
        !date ||
        (type !== "PRODUCT" && type !== "SERVICE" && type !== "REALESTATE")
      ) {
        return;
      }

      if (!dateMap[date]) {
        dateMap[date] = createEmptyEntry();
      }

      const target = dateMap[date];

      if (type === "PRODUCT") {
        target[`${key}ProductAmount`] = toNumber(item?.[amountField]);
        target[`${key}ProductCount`] = toNumber(item?.[countField]);
      } else if (type === "SERVICE") {
        target[`${key}ServiceAmount`] = toNumber(item?.[amountField]);
        target[`${key}ServiceCount`] = toNumber(item?.[countField]);
      } else {
        target[`${key}RealestateAmount`] = toNumber(item?.[amountField]);
        target[`${key}RealestateCount`] = toNumber(item?.[countField]);
      }
    });
  };
  const datasets = [
    {
      label: "POS Product",
      fill: true,
      borderRadius: 4,
      borderColor: "#2DDF89",
      backgroundColor: "#2DDF89",
      pointBorderColor: "#2DDF89",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "POS Service",
      fill: true,
      borderRadius: 4,
      borderColor: "#EC4E0F",
      backgroundColor: "#EC4E0F",
      pointBorderColor: "#EC4E0F",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "Online Product",
      fill: true,
      borderRadius: 4,
      borderColor: "#002872",
      backgroundColor: "#002872",
      pointBorderColor: "#002872",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "POS Realestate",
      fill: true,
      borderRadius: 4,
      borderColor: "#7A3FF2",
      backgroundColor: "#7A3FF2",
      pointBorderColor: "#7A3FF2",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "Online Service",
      fill: true,
      borderRadius: 4,
      borderColor: "#1C1F37",
      backgroundColor: "#1C1F37",
      pointBorderColor: "#1C1F37",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "Online Realestate",
      fill: true,
      borderRadius: 4,
      borderColor: "#A66BFF",
      backgroundColor: "#A66BFF",
      pointBorderColor: "#A66BFF",
      borderWidth: 2,
      yAxisID: "y",
      minBarLength: 6,
      data: [],
    },
    {
      label: "POS Order Count",
      fill: true,
      borderRadius: 4,
      borderColor: "rgba(45, 223, 137, 0.45)",
      backgroundColor: "rgba(45, 223, 137, 0.45)",
      pointBorderColor: "rgba(45, 223, 137, 0.45)",
      borderWidth: 1,
      yAxisID: "y1",
      minBarLength: 6,
      data: [],
    },
    {
      label: "Online Order Count",
      fill: true,
      borderRadius: 4,
      borderColor: "rgba(0, 40, 114, 0.45)",
      backgroundColor: "rgba(0, 40, 114, 0.45)",
      pointBorderColor: "rgba(0, 40, 114, 0.45)",
      borderWidth: 1,
      yAxisID: "y1",
      minBarLength: 6,
      data: [],
    },
  ];

  setEntry(
    posOrderList,
    posOrderAmountField,
    posOrderCountField,
    posDateField,
    posTypeField,
    "pos"
  );
  setEntry(
    onlineOrderList,
    onlineOrderAmountField,
    onlineOrderCountField,
    onlineDateField,
    onlineTypeField,
    "online"
  );

  let labels = Object.keys(dateMap).sort(
    (firstDate, secondDate) =>
      moment(firstDate, "YYYY-MM-DD").valueOf() -
      moment(secondDate, "YYYY-MM-DD").valueOf()
  );

  if (labels.length > 0 && labels.length < minCol) {
    const paddedLabels = [];
    const firstDate = moment(labels[0], "YYYY-MM-DD");

    for (let index = minCol - labels.length; index > 0; index -= 1) {
      paddedLabels.push(moment(firstDate).subtract(index, "days").format("YYYY-MM-DD"));
    }

    labels = [...paddedLabels, ...labels];
  }

  labels.forEach((label) => {
    const entry = dateMap[label] || createEmptyEntry();

    datasets[0].data.push(entry.posProductAmount);
    datasets[1].data.push(entry.posServiceAmount);
    datasets[2].data.push(entry.onlineProductAmount);
    datasets[3].data.push(entry.posRealestateAmount);
    datasets[4].data.push(entry.onlineServiceAmount);
    datasets[5].data.push(entry.onlineRealestateAmount);
    datasets[6].data.push(
      entry.posProductCount + entry.posServiceCount + entry.posRealestateCount
    );
    datasets[7].data.push(
      entry.onlineProductCount +
        entry.onlineServiceCount +
        entry.onlineRealestateCount
    );
  });

  return {
    labels,
    datasets,
  };
}
